export default "__VITE_ASSET__ByiGeDNn__"